import React, { useState } from "react";


import {
  ListIcon
} from "../../icons";

interface ComponentCardProps {
  title: string;
  children: React.ReactNode;
  className?: string; // Additional custom classes for styling
  desc?: string; // Description text
  btn?:string
  filter?: boolean; // Flag to show filter option
}

const ComponentCard: React.FC<ComponentCardProps> = ({
  title,
  children,
  className = "",
  desc = "",
  btn = "",
  filter = false
}) => {

  const [filterSection, setFilterSection] = useState(false);

  return (
    <div
      className={`rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] ${className}`}
    >
      {/* Card Header */}
      <div className={"px-6 py-5 "+(btn !== "" ? "flex justify-between" : "")}>
        <h3 className="text-base font-medium text-gray-800 dark:text-white/90">
          {title}
        </h3>
        {desc && (
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            {desc}
          </p>
        )}

        {filter && (
          <a
            href={"javascript:void(0)"}
            onClick={() => setFilterSection(!filterSection)}
            className={'text-indigo-600 ring-1 ring-indigo-200 ring-inset hover:ring-indigo-300 shadow-xs focus-visible:outline-indigo-500 rounded-md px-2.5 py-2.5 text-center text-sm inline-block'}
          >
            <ListIcon />
          </a>
        )}

        {btn !== "" && (
          <a
            href={btn}
            className={'float-end text-indigo-600 ring-1 ring-indigo-200 ring-inset hover:ring-indigo-300 focus-visible:outline-indigo-600 inline-block rounded-md px-3.5 py-2.5 text-center text-sm font-semibold focus-visible:outline-2 focus-visible:outline-offset-2'}
          >
            Add New
          </a>
        )}
      </div>

      {/* Card Body */}
      <div className={"p-4 border-t border-gray-100 dark:border-gray-800 sm:p-6 "+(filterSection ? '' : 'show-filter')}>
        <div className="space-y-6">{children}</div>
      </div>
    </div>
  );
};

export default ComponentCard;
